export const categories = [
    {
        label: 'Telegram',
        value: '32'
    },
    {
        label: 'Бизнес и стартапы',
        value: '12'
    },
    {
        label: 'Блоги',
        value: '4'
    },
    {
        label: 'Букмекерство',
        value: '46'
    },
    {
        label: 'Видео и фильмы',
        value: '11'
    },
    {
        label: 'Даркнет',
        value: '55'
    },
    {
        label: 'Дизайн',
        value: '34'
    },
    {
        label: 'Для взрослых',
        value: '8'
    },
    {
        label: 'Другое',
        value: '17'
    },
    {
        label: 'Еда и кулинария',
        value: '3'
    },
    {
        label: 'Здоровье и Фитнес',
        value: '45'
    },
    {
        label: 'Игры',
        value: '44'
    },
    {
        label: 'Инстаграм',
        value: '47'
    },
    {
        label: 'Интерьер и строительство',
        value: '53'
    },
    {
        label: 'Искусство',
        value: '49'
    },
    {
        label: 'Картинки и фото',
        value: '7'
    },
    {
        label: 'Карьера',
        value: '23'
    },
    {
        label: 'Книги',
        value: '15'
    },
    {
        label: 'Криптовалюты',
        value: '22'
    },
    {
        label: 'Курсы и гайды',
        value: '48'
    },
    {
        label: 'Лингвистика',
        value: '21'
    },
    {
        label: 'Маркетинг, PR, реклама',
        value: '31'
    },
    {
        label: 'Медицина',
        value: '28'
    },
    {
        label: 'Мода и красота',
        value: '27'
    },
    {
        label: 'Музыка',
        value: '13'
    },
    {
        label: 'Новости и СМИ',
        value: '2'
    },
    {
        label: 'Образование',
        value: '5'
    },
    {
        label: 'Познавательное',
        value: '41'
    },
    {
        label: 'Политика',
        value: '38'
    },
    {
        label: 'Право',
        value: '50'
    },
    {
        label: 'Природа',
        value: '37'
    },
    {
        label: 'Продажи',
        value: '14'
    },
    {
        label: 'Психология',
        value: '33'
    },
    {
        label: 'Путешествия',
        value: '25'
    },
    {
        label: 'Религия',
        value: '40'
    },
    {
        label: 'Рукоделие',
        value: '26'
    },
    {
        label: 'Семья и дети',
        value: '36'
    },
    {
        label: 'Софт и приложения',
        value: '9'
    },
    {
        label: 'Спорт',
        value: '20'
    },
    {
        label: 'Технологии',
        value: '1'
    },
    {
        label: 'Транспорт',
        value: '29'
    },
    {
        label: 'Цитаты',
        value: '16'
    },
    {
        label: 'Шок-контент',
        value: '52'
    },
    {
        label: 'Эзотерика',
        value: '54'
    },
    {
        label: 'Экономика',
        value: '10'
    },
    {
        label: 'Эротика',
        value: '51'
    },
    {
        label: 'Юмор и развлечения',
        value: '6'
    }
]
